import Image from 'next/legacy/image';
import { CommonCustomerItem, DealTypeForTab } from 'types';
import { NextLink } from 'components/NextLink';
import { BrandType } from './BrandsList';

import cx from 'classnames';
import styles from './Brands.module.scss';

export type BrandProps = {
  isActiveItem?: boolean;
  customClass?: string;
  filter?: 'brands' | 'activities';
  onClick?: (slug: string) => void;
  tab?: DealTypeForTab;
  brand: CommonCustomerItem;
  type?: BrandType;
  withOpacity?: boolean;
  withTitle?: boolean;
};

export const Brands = ({
  isActiveItem,
  customClass,
  filter = 'brands',
  onClick,
  type = 'common',
  brand,
  tab,
  withOpacity = true,
  withTitle,
  smallerMobile,
  isRawSvg,
  objectFit = 'cover',
}: BrandProps) => {
  const renderImage = () => {
    if(isRawSvg) {
      const buff = new Buffer(brand.svg);
      const base64data = buff.toString('base64');

      return (
        <div className={styles.svgPadding}>
          <Image alt={brand.title} src={`data:image/svg+xml;base64,${base64data}`} layout="fill" objectFit="contain" />
        </div>
      )
    }
    return (
      <>
        <Image alt={brand.title} src={brand.logo || ''} layout="fill" objectFit={objectFit} />
        {withTitle && <h3>{brand.title}</h3>}
      </>
    );
  }

  return (
    <div
      className={cx(
        styles.brand,
        {
          [styles.halfed]: type === 'halfed',
          [styles.inline]: type === 'inline',
          [styles.inline]: type === 'inlineFeed',
          [styles.withOpacity]: withOpacity,
          [styles.lightBorder]: !withOpacity,
          [styles.activeItem]: isActiveItem,
          [styles.smallerMobile]: smallerMobile,
        },
        customClass,
      )}
    >
      {onClick ? (
        <div style={{cursor: 'pointer'}} onClick={() => onClick(brand.slug || '')}>{renderImage()}</div>
      ) : (
        <NextLink href={`/gear?${filter}=["${brand.slug}"]${tab && tab !== 'all' ? '&type=' + tab : ''}`}>
          {renderImage()}
        </NextLink>
      )}
    </div>
  );
};
